import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, Input, InputNumber, Form, Message, IconButton, Icon } from 'rsuite'
import { isValidators, requiredFiled } from '../../../../utils/ValidatorUtils'
import ErrorMessage from '../../../../components/message/errorMessage/ErrorMessage'
import CustomIconMessageInfo from '../../../../widgets/CustomIconMessageInfo'
import scrollToComponent from 'react-scroll-to-component'
import ContributionBudgetTable from './ContributionBudgetTable'
import NumberFormat from 'react-number-format'

export default function ContributionBudgetForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  onSubmit,
  onDelete,
  ...props
}) {
  const { isDeleteError, isError, loading } = props

  const [schema, setSchema] = useState(_schema)
  const [section, setSection] = useState()
  const [isAdd, setIsAdd] = useState(false)
  const [editId, setEditId] = useState()
  const [isDeleteFail, setIsDeleteFail] = useState(false)
  const [isSaveError, setIsSaveError] = useState(false)
  const [organization, setOrganization] = useState()
  const [budget, setBudget] = useState()
  const [otherSupport, setOtherSupport] = useState()

  useEffect(() => {
    setSchema(_schema)
    setIsAdd(isError)
    setIsDeleteFail(isDeleteError)
  }, [_schema])

  useEffect(() => {
    setIsSaveError(isError)
    setIsAdd(isError)
  }, [isError])

  useEffect(() => {
    setIsDeleteFail(isDeleteError)
  }, [isDeleteError])

  const onAdd = () => {
    setValue('selectedIndex', -1)
    setEditId(-1)
    setOrganization()
    setBudget()
    setOtherSupport()
    setIsAdd(true)
    setIsSaveError(false)
    setIsDeleteFail(false)
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  const handleEdit = (rowData, index) => {
    // let data = schema.value[index]
    setValue('selectedIndex', index)
    setValue('selectedIndex', index)
    setOrganization(rowData.organization)
    setBudget(rowData.budget)
    setOtherSupport(rowData.otherSupport)
    setIsAdd(true)
    setEditId(index)
    setIsSaveError(false)
    setIsDeleteFail(false)
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  return (
    <>
      <Panel
        header={schema.contributionBudgetText}
        style={{ marginBottom: 5 }}
        ref={(section) => {
          setSection(section)
        }}
      >
        {isAdd && (
          <Form fluid style={{ marginTop: -10 }}>
            <Controller
              key={'selectedIndex'}
              name={'selectedIndex'}
              control={control}
              defaultValue={editId}
            />
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 15 }}>
                {schema.message &&
                  schema.message.map((item) => {
                    return <Message showIcon type={item.type} description={item.description} />
                  })}

                {schema.description && <CustomIconMessageInfo contents={schema.description} />}
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: 15 }}>
                <ErrorMessage error={errors[schema.organization.name]} />
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: 15 }}>
                <ErrorMessage error={errors[schema.budget.name]} />
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: 15 }}>
                <ErrorMessage error={errors[schema.otherSupport.name]} />
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: 15 }}>
                {requiredFiled(schema.organization.validators, schema.organization.label)}

                <Controller
                  key={schema.organization.name}
                  name={schema.organization.name}
                  control={control}
                  rules={isValidators(schema.organization.validators)}
                  defaultValue={organization || ''}
                  render={(props) => {
                    return (
                      <Input
                        name={schema.organization.name}
                        value={organization}
                        placeholder={schema.organization.hint}
                        inputRef={register(isValidators(schema.organization.validators))}
                        onChange={(e) => {
                          props.onChange(e)
                          setOrganization(e)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: 15 }}>
                {requiredFiled(schema.budget.validators, schema.budget.label)}

                <Controller
                  key={schema.budget.name}
                  name={schema.budget.name}
                  control={control}
                  rules={isValidators(schema.budget.validators)}
                  defaultValue={budget || ''}
                  render={(props) => {
                    return (
                      // <InputNumber
                      //   disabled={schema.budget.disabled}
                      //   value={budget}
                      //   placeholder={schema.budget.hint}
                      //   onChange={(value) => {
                      //     props.onChange(value)
                      //     setBudget(value)
                      //   }}
                      // />
                      <NumberFormat
                        className="rs-input"
                        thousandSeparator={true}
                        disabled={schema.budget.disabled}
                        value={budget}
                        placeholder={schema.budget.hint}
                        onValueChange={(e) => {
                          props.onChange(e.floatValue)
                          setBudget(e.floatValue)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: 15 }}>
                {requiredFiled(schema.otherSupport.validators, schema.otherSupport.label)}
                <Controller
                  key={schema.otherSupport.name}
                  name={schema.otherSupport.name}
                  control={control}
                  rules={isValidators(schema.otherSupport.validators)}
                  defaultValue={otherSupport || ''}
                  render={(props) => {
                    return (
                      <Input
                        name={schema.otherSupport.name}
                        value={otherSupport}
                        placeholder={schema.otherSupport.hint}
                        inputRef={register(isValidators(schema.otherSupport.validators))}
                        onChange={(e) => {
                          props.onChange(e)
                          setOtherSupport(e)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </Row>

            {isSaveError && (
              <Row style={{ marginBottom: 10 }}>
                <Message
                  showIcon
                  type="error"
                  description={`บันทึก ${schema.buttonText ? schema.buttonText : ''} ไม่สำเร็จ`}
                />
              </Row>
            )}

            <Row style={{ marginTop: 10 }}>
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5, marginBottom: 5 }}>
                <div>
                  <IconButton
                    appearance="ghost"
                    // className={editId === -1 ? '' : 'rs-btn-ghost-edit'}
                    icon={
                      <Icon
                        // className={
                        //   editId === -1 ? 'bt-gost-icon-radius' : 'bt-gost-icon-radius-edit'
                        // }
                        className={'bt-gost-icon-radius'}
                        icon={editId === -1 ? 'save' : 'edit'}
                      />
                    }
                    onClick={onSubmit}
                    style={{ marginRight: 5 }}
                    disabled={loading}
                  >
                    {editId === -1 ? 'บันทึก' : 'บันทึกแก้ไข'}
                    {schema.buttonText && schema.buttonText}
                  </IconButton>
                  <IconButton
                    appearance="ghost"
                    className="rs-btn-ghost-cancel"
                    icon={<Icon className="bt-gost-icon-radius-cancel" icon="close" />}
                    onClick={(e) => {
                      setIsAdd(false)
                      setIsSaveError(false)
                      scrollToComponent(section, { offset: 1, align: 'top', duration: 500 })
                    }}
                    style={{ marginRight: 5 }}
                    disabled={loading}
                  >
                    {/* ยกเลิก */}
                    {`ยกเลิก${editId === -1 ? 'บันทึก' : 'แก้ไข'}`}
                    {schema.contributionBudgetText && schema.contributionBudgetText}
                  </IconButton>
                </div>
              </Col>
            </Row>
          </Form>
        )}

        {!isAdd && (
          <Row style={{ marginTop: -10 }}>
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5, marginBottom: 5 }}>
              <div>
                <IconButton
                  appearance="ghost"
                  icon={<Icon className="bt-gost-icon-radius" icon="plus" />}
                  onClick={onAdd}
                  style={{ marginRight: 5 }}
                >
                  {`เพิ่ม${schema.buttonText && schema.buttonText}`}
                </IconButton>
              </div>
            </Col>
          </Row>
        )}

        {isDeleteFail && (
          <Row style={{ marginBottom: 10 }}>
            <Message
              showIcon
              type="error"
              description={`ลบ ${schema.buttonText ? schema.buttonText : ''} ไม่สำเร็จ`}
            />
          </Row>
        )}

        <Row style={{ marginTop: 10 }}>
          <ContributionBudgetTable
            schema={schema}
            isEdit={true}
            onDelete={onDelete}
            onEdit={handleEdit}
          />
        </Row>
      </Panel>
    </>
  )
}
